import React from 'react';
import { useTranslation } from 'react-i18next';
import { projectEpisodePath } from '../../../utils/routes';

const episodeBadgeBase: React.CSSProperties = { fontSize: '0.65rem', padding: '1px 5px', borderRadius: '4px', fontWeight: 500 };

export const EpisodeBadges: React.FC<{ projectId?: string, episodes?: number[], collapsed?: boolean, episodeMap?: Map<number, string> }> = ({ projectId, episodes, collapsed, episodeMap }) => {
  const { t } = useTranslation('projectDetail');
  if (collapsed) {
    if (!episodes || episodes.length === 0) {
      // 占位，与可见徽章完全相同的尺寸，仅隐藏，保证状态列高度一致
      return <span style={{ ...episodeBadgeBase, visibility: 'hidden' }}>{t('analysis.nEpisodes', { n: 0 })}</span>;
    }
    return (
      <span style={{ ...episodeBadgeBase, background: 'rgba(59, 130, 246, 0.1)', color: 'var(--theme-scene)' }}>
        {t('analysis.nEpisodes', { n: episodes.length })}
      </span>
    );
  }
  if (!episodes || episodes.length === 0) return null;
  return (
    <span style={{ display: 'inline-flex', gap: '3px', flexWrap: 'wrap', justifyContent: 'flex-start' }}>
      {[...episodes].sort((a, b) => a - b).map(ep => {
        const epId = episodeMap?.get(ep);
        return epId && projectId ? (
          <a key={ep} href={projectEpisodePath(projectId, epId)} target="_blank" rel="noopener noreferrer" style={{ fontSize: '0.65rem', padding: '1px 5px', borderRadius: '4px', background: 'rgba(59, 130, 246, 0.1)', color: 'var(--theme-scene)', fontWeight: 500, textDecoration: 'none' }}>
            {t('analysis.episodeLink', { n: ep })}
          </a>
        ) : (
          <span key={ep} style={{ fontSize: '0.65rem', padding: '1px 5px', borderRadius: '4px', background: 'rgba(59, 130, 246, 0.1)', color: 'var(--theme-scene)', fontWeight: 500 }}>
            {t('analysis.episodeLink', { n: ep })}
          </span>
        );
      })}
    </span>
  );
};
